<template>
  <div class="SearchResults-desktop">
    <div class="SearchSuggestion SearchInput">
      <search-auto-complete-alg :is-a-search-filter="true" />
    </div>
  </div>
</template>
<script>
import searchAutoCompleteAlg from './search-auto-complete-alg.vue';

export default {
  components: {
    searchAutoCompleteAlg,
  },
};
</script>

<style lang="scss">
  @import "../../../../scss/abstracts/abstracts";

  .SearchSuggestion{
    margin-bottom: spacing();
  }

  .SearchResults-desktop {
    @include respond-to(md, max-width) {
      display: none;
    }
  }
</style>
